// Complete list of countries to use in nationality filter
export const countries = [
  "Afghanistan", "Albania", "Algeria", "Andorra", "Angola", "Antigua and Barbuda", 
  "Argentina", "Armenia", "Australia", "Austria", "Azerbaijan", "Bahamas", "Bahrain", 
  "Bangladesh", "Barbados", "Belarus", "Belgium", "Belize", "Benin", "Bhutan", "Bolivia", 
  "Bosnia and Herzegovina", "Botswana", "Brazil", "Brunei", "Bulgaria", "Burkina Faso", 
  "Burundi", "Cabo Verde", "Cambodia", "Cameroon", "Canada", "Central African Republic", 
  "Chad", "Chile", "China", "Colombia", "Comoros", "Congo", "Costa Rica", "Croatia", 
  "Cuba", "Cyprus", "Czech Republic", "Denmark", "Djibouti", "Dominica", "Dominican Republic", 
  "Ecuador", "Egypt", "El Salvador", "Equatorial Guinea", "Eritrea", "Estonia", "Eswatini", 
  "Ethiopia", "Fiji", "Finland", "France", "Gabon", "Gambia", "Georgia", "Germany", 
  "Ghana", "Greece", "Grenada", "Guatemala", "Guinea", "Guinea-Bissau", "Guyana", "Haiti", 
  "Honduras", "Hungary", "Iceland", "India", "Indonesia", "Iran", "Iraq", "Ireland", 
  "Israel", "Italy", "Jamaica", "Japan", "Jordan", "Kazakhstan", "Kenya", "Kiribati", 
  "Kosovo", "Kuwait", "Kyrgyzstan", "Laos", "Latvia", "Lebanon", "Lesotho", "Liberia", 
  "Libya", "Liechtenstein", "Lithuania", "Luxembourg", "Madagascar", "Malawi", "Malaysia", 
  "Maldives", "Mali", "Malta", "Marshall Islands", "Mauritania", "Mauritius", "Mexico", 
  "Micronesia", "Moldova", "Monaco", "Mongolia", "Montenegro", "Morocco", "Mozambique", 
  "Myanmar", "Namibia", "Nauru", "Nepal", "Netherlands", "New Zealand", "Nicaragua", 
  "Niger", "Nigeria", "North Korea", "North Macedonia", "Norway", "Oman", "Pakistan", 
  "Palau", "Palestine", "Panama", "Papua New Guinea", "Paraguay", "Peru", "Philippines", 
  "Poland", "Portugal", "Qatar", "Romania", "Russia", "Rwanda", "Saint Kitts and Nevis", 
  "Saint Lucia", "Saint Vincent and the Grenadines", "Samoa", "San Marino", 
  "Sao Tome and Principe", "Saudi Arabia", "Senegal", "Serbia", "Seychelles", "Sierra Leone", 
  "Singapore", "Slovakia", "Slovenia", "Solomon Islands", "Somalia", "South Africa", 
  "South Korea", "South Sudan", "Spain", "Sri Lanka", "Sudan", "Suriname", "Sweden", 
  "Switzerland", "Syria", "Taiwan", "Tajikistan", "Tanzania", "Thailand", "Timor-Leste", 
  "Togo", "Tonga", "Trinidad and Tobago", "Tunisia", "Turkey", "Turkmenistan", "Tuvalu", 
  "Uganda", "Ukraine", "United Arab Emirates", "United Kingdom", "United States", "Uruguay", 
  "Uzbekistan", "Vanuatu", "Vatican City", "Venezuela", "Vietnam", "Yemen", "Zambia", "Zimbabwe"
];

// Soccer/football positions in ordered groups
export const positionGroups = [
  { 
    label: "Goalkeeper", 
    positions: ["Goalkeeper (GK)"] 
  },
  { 
    label: "Defender", 
    positions: [
      "Center Back (CB)", 
      "Right Back (RB)", 
      "Left Back (LB)", 
      "Right Wing-Back (RWB)", 
      "Left Wing-Back (LWB)"
    ] 
  },
  { 
    label: "Midfielder", 
    positions: [
      "Defensive Midfielder (DM)", 
      "Central Midfielder (CM)", 
      "Attacking Midfielder (AM)", 
      "Right Midfielder (RM)", 
      "Left Midfielder (LM)"
    ] 
  },
  { 
    label: "Forward", 
    positions: [
      "Right Winger (RW)", 
      "Left Winger (LW)", 
      "Center Forward (CF)", 
      "Striker (ST)"
    ] 
  }
];

// All possible playing levels
export const playingLevels = [
  "D1", 
  "D2", 
  "D3", 
  "NAIA",
  "NJCAA", 
  "JUCO",
  "Professional Academy",
  "Professional Youth Team",
  "Professional Reserve Team",
  "Professional First Team",
  "High School",
  "Club",
  "Semi-Professional"
];

// All possible event values
export const eventOptions = [
  "Dallas Cup",
  "ECNL Showcase",
  "Stanford ID Camp",
  "State Championship",
  "MLS Next Cup",
  "Surf Cup",
  "ODP Regional Camp",
  "GA National Finals",
  "Other"
];

// Main position categories
export const mainPositions = [
  "Goalkeeper",
  "Defender",
  "Midfielder",
  "Forward"
];

// Specific positions ordered list for filter
export const specificPositions = [
  "Goalkeeper",
  "Right Back",
  "Center Back",
  "Left Back",
  "Right Wingback",
  "Left Wingback",
  "Defensive Midfielder",
  "Right Midfielder",
  "Center Midfielder",
  "Left Midfielder",
  "Right Winger",
  "Left Winger",
  "Attacking Midfielder",
  "Striker"
];